import { notifyError } from '@/services/infrastructure/notification.service'
import type { ComponentPublicInstance } from 'vue'
import type { Problem } from '@/types/Problem'

export function globalErrorHandler(
  err: unknown,
  instance: ComponentPublicInstance | null,
  info: string
): void {
  let description: string | { descriptionMessage: string, error: any } = info

  // Axios error detection
  if (err && typeof err === 'object' && 'isAxiosError' in err) {
    const axiosErr = err as any
    if (axiosErr.response && axiosErr.response.data) {
      const problem = axiosErr.response.data as Problem
      // Prefer status from Problem, fallback to axiosErr.response.status
      const status = problem.status || axiosErr.response.status
      description = {
        descriptionMessage: status
          ? `HTTP ${status} ${problem.detail || 'API error'}`
          : problem.detail || 'API error',
        error: problem
      }
    } else {
      description = {
        descriptionMessage: axiosErr.message || 'Network error',
        error: axiosErr
      }
    }
  } else if (err instanceof Error) {
    description = {
      descriptionMessage: err.message,
      error: err
    }
  }

  notifyError({
    title: 'Unexpected Error',
    description
  })
}
